// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/taco-robricks/robobricks-top-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/taco-robricks/Ta-Co-Robobrics-mobile-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.taCoRoboTopBanner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 28.3vw;
}

.about-robo-pointers {
  padding: 0 5%;
}

.about-robo-pointers ul li {
  padding-bottom: 20px;
}

.tcr-yt-video::after {
  content: "";
  position: absolute;
  background-color: #e5e5e5;
  width: 2px;
  height: 250px;
  left: 56%;
  top: 5%;
}

.video-auth {
  padding-bottom: 50px;
}

.auth-img {
  text-align: center;
}

.auth-img img {
  height: auto;
  width: 45%;
}

/* Robobricks Kit  */
.robobricks {
  background-color: #f5f6fb;
}

/* .robobricks-kit-content {
  padding: 0 50px;
} */

.robobricks-kit-content ul li {
  padding-bottom: 20px;
}

.robobricks-kit-img {
  text-align: center;
}

.robobricks-kit-img img {
  height: auto;
  width: 95%;
}

.robobricks-edu-img-b {
  border: 1px solid #a5a5a5;
}

.robobricks-yt-content-wrapper ul li {
  padding-bottom: 30px;
}

.educators-testimony {
  background-color: #f5f6fb;
}

.robobricks-yt-content-wrapper ul li, .about-robo-pointers ul li, .robobricks-kit-content ul li {
  text-align: justify;
}

@media (max-width: 1024px) {
  .robobricks-yt-video {
    padding-bottom: 20px;
  }

  .video-auth {
    margin-bottom: 30px;
  }

  .tcr-yt-video iframe {
    height: auto !important;
    width: 100% !important;
  }

  .auth-img img {
    width: 30%;
  }

  .tcr-yt-video::after {
    height: 100px;
  }
}

@media (max-width: 576px) {
  .taCoRoboTopBanner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 127.2vw;
  }

  .sub-heading-npgs {
    padding: 0px;
  }

  .about-robo-pointers {
    padding: 0;
    padding: initial;
  }

  .robobricks-edu-img-a {
    padding-bottom: 10px;
  }

  .empoweringFluidPlay {
    padding-bottom: 20px;
  }

  .tcr-yt-video {
    /* padding-right: 50px; */
  }

  .auth-img img {
    width: 50%;
  }

  .tcr-yt-video iframe {
    height: 185px;
    width: 335px;
  }

  .tcr-yt-video::after {
    display: none;
  }

  .robobricks-kit-content {
    padding: 0;
    padding: initial;
  }

  .robobricks-kit-img img {
    padding: 0;
    padding: initial;
  }

  .robobricks-yt-video iframe {
    height: 215px;
    width: 330px;
  }

  .robobricks-yt-video {
    padding-bottom: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/indivdual-product-pages/TaCo-Robobricks/TaCoRobobricks.css"],"names":[],"mappings":"AAAA;EACE,yDAA0F;EAC1F,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,SAAS;EACT,OAAO;AACT;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,yDAAkG;IAClG,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".taCoRoboTopBanner {\n  background-image: url(\"../../../../public/images/taco-robricks/robobricks-top-banner.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 28.3vw;\n}\n\n.about-robo-pointers {\n  padding: 0 5%;\n}\n\n.about-robo-pointers ul li {\n  padding-bottom: 20px;\n}\n\n.tcr-yt-video::after {\n  content: \"\";\n  position: absolute;\n  background-color: #e5e5e5;\n  width: 2px;\n  height: 250px;\n  left: 56%;\n  top: 5%;\n}\n\n.video-auth {\n  padding-bottom: 50px;\n}\n\n.auth-img {\n  text-align: center;\n}\n\n.auth-img img {\n  height: auto;\n  width: 45%;\n}\n\n/* Robobricks Kit  */\n.robobricks {\n  background-color: #f5f6fb;\n}\n\n/* .robobricks-kit-content {\n  padding: 0 50px;\n} */\n\n.robobricks-kit-content ul li {\n  padding-bottom: 20px;\n}\n\n.robobricks-kit-img {\n  text-align: center;\n}\n\n.robobricks-kit-img img {\n  height: auto;\n  width: 95%;\n}\n\n.robobricks-edu-img-b {\n  border: 1px solid #a5a5a5;\n}\n\n.robobricks-yt-content-wrapper ul li {\n  padding-bottom: 30px;\n}\n\n.educators-testimony {\n  background-color: #f5f6fb;\n}\n\n.robobricks-yt-content-wrapper ul li, .about-robo-pointers ul li, .robobricks-kit-content ul li {\n  text-align: justify;\n}\n\n@media (max-width: 1024px) {\n  .robobricks-yt-video {\n    padding-bottom: 20px;\n  }\n\n  .video-auth {\n    margin-bottom: 30px;\n  }\n\n  .tcr-yt-video iframe {\n    height: auto !important;\n    width: 100% !important;\n  }\n\n  .auth-img img {\n    width: 30%;\n  }\n\n  .tcr-yt-video::after {\n    height: 100px;\n  }\n}\n\n@media (max-width: 576px) {\n  .taCoRoboTopBanner {\n    background-image: url(\"../../../../public/images/taco-robricks/Ta-Co-Robobrics-mobile-banner.jpg\");\n    height: 127.2vw;\n  }\n\n  .sub-heading-npgs {\n    padding: 0px;\n  }\n\n  .about-robo-pointers {\n    padding: unset;\n  }\n\n  .robobricks-edu-img-a {\n    padding-bottom: 10px;\n  }\n\n  .empoweringFluidPlay {\n    padding-bottom: 20px;\n  }\n\n  .tcr-yt-video {\n    /* padding-right: 50px; */\n  }\n\n  .auth-img img {\n    width: 50%;\n  }\n\n  .tcr-yt-video iframe {\n    height: 185px;\n    width: 335px;\n  }\n\n  .tcr-yt-video::after {\n    display: none;\n  }\n\n  .robobricks-kit-content {\n    padding: unset;\n  }\n\n  .robobricks-kit-img img {\n    padding: unset;\n  }\n\n  .robobricks-yt-video iframe {\n    height: 215px;\n    width: 330px;\n  }\n\n  .robobricks-yt-video {\n    padding-bottom: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
